import { render, staticRenderFns } from "./EditMuseum.vue?vue&type=template&id=4025d141&scoped=true&"
import script from "./EditMuseum.vue?vue&type=script&lang=js&"
export * from "./EditMuseum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025d141",
  null
  
)

export default component.exports